import getConfig from 'next/config'

const { SEGMENT_IDENTITY_STORAGE_KEY } = getConfig().publicRuntimeConfig

export function resetTrackingIdentity() {
  if (!global.analytics) return false
  if (
    typeof sessionStorage !== 'undefined' &&
    sessionStorage.getItem(SEGMENT_IDENTITY_STORAGE_KEY)
  ) {
    sessionStorage.removeItem(SEGMENT_IDENTITY_STORAGE_KEY)
  }

  global.analytics.reset()
}
